var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    _setup.CModal,
    {
      attrs: { title: _setup.props.title },
      on: { ok: _setup.props.handleClose },
      scopedSlots: _vm._u([
        {
          key: "modal-title",
          fn: function () {
            return [
              _c("font-awesome-icon", {
                staticStyle: { color: "#ffd43b" },
                attrs: { icon: ["fas", "triangle-exclamation"] },
              }),
              _vm._v(" "),
              _c("b", [_vm._v("There was a problem")]),
            ]
          },
          proxy: true,
        },
      ]),
      model: {
        value: _setup.props.isOpen,
        callback: function ($$v) {
          _vm.$set(_setup.props, "isOpen", $$v)
        },
        expression: "props.isOpen",
      },
    },
    [
      _vm._v(" "),
      _c("div", { staticClass: "row justify-content-between ml-2" }, [
        _c("div", { ref: "errorMessage", staticClass: "col" }, [
          _c("div", [_vm._v(_vm._s(_vm.modalErrorDescription))]),
          _vm._v(" "),
          _c("div", [
            _vm._v(
              "Please, contact our support team so they can help you out."
            ),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-2" }, [
          _c(
            "button",
            {
              staticClass: "btn copy-btn float-right",
              on: { click: _setup.copyErrorMessage },
            },
            [
              _c("font-awesome-icon", {
                staticStyle: { color: "#000000" },
                attrs: { icon: ["fas", "copy"], size: "lg" },
              }),
            ],
            1
          ),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }